/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Accordion from './modules/accordion';
import Modal from './modules/modal';

import ColumnScroll from './modules/column-scroll';
import ContentStickScroll from './modules/content-stick-scroll';
import Hero from './modules/hero';
import NewsScroll from './modules/news-scroll';
import Offices from './modules/offices';
import ReadMore from './modules/read-more';
import ScrollAnimation from './modules/scroll-animation';
import ServicesScroll from './modules/services-scroll';
import SiteHead from './modules/site-head';
import StickyBanner from './modules/sticky-banner';
import StickScroll from './modules/stick-scroll';
import StickScrollTeam from './modules/stick-scroll-team';
import TeamScroll from './modules/team-scroll';

import Carousel from './modules/carousels/carousel';
import Card from './modules/carousels/card';
import InsightCarousel from './modules/carousels/insight';
import MasterHeroCarousel from './modules/carousels/master-hero';
import SectorsCarousel from './modules/carousels/sectors';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {
                    // case 'accordion':
                    //     let accordionInstance = new Accordion(item);
                    //     accordionInstance.init();
                    //     break;

                    case 'carousel':
                        let carouselInstance = new Carousel(item);
                        carouselInstance.init();
                        break;

                    case 'insight-carousel':
                        let insightCarouselInstance = new InsightCarousel(item);
                        insightCarouselInstance.init();
                        break;

                    case 'master-hero':
                        let masterHeroInstance = new MasterHeroCarousel(item);
                        masterHeroInstance.init();
                        break;

                    case 'sector-carousel':
                        let sectorsCarouselInstance = new SectorsCarousel(item);
                        sectorsCarouselInstance.init();
                        break;

                    case 'content-stick-scroll':
                        let contentStickScrollInstance = new ContentStickScroll(item);
                        contentStickScrollInstance.init();
                        break;

                    case 'column-scroll':
                        let columnScrollInstance = new ColumnScroll(item);
                        columnScrollInstance.init();
                        break;

                    case 'news-scroll':
                        let newsScrollInstance = new NewsScroll(item);
                        newsScrollInstance.init();
                        break;

                    case 'read-more':
                        let readMoreInstance = new ReadMore(item);
                        readMoreInstance.init();
                        break;

                    case 'scroll-animation':
                        let scrollAnimationInstance = new ScrollAnimation(item);
                        scrollAnimationInstance.init();
                        break;

                    case 'offices':
                        let officesInstance = new Offices(item);
                        officesInstance.init();
                        break;

                    case 'site-head':
                        let siteHeadInstance = new SiteHead(item);
                        siteHeadInstance.init();
                        break;

                    case 'sticky-banner':
                        let stickyBannerInstance = new StickyBanner(item);
                        stickyBannerInstance.init();
                        break;

                    case 'stick-scroll':
                        let stickScrollInstance = new StickScroll(item);
                        stickScrollInstance.init();
                        break;

                    case 'stick-scroll-team':
                        let stickScrollTeamInstance = new StickScrollTeam(item);
                        stickScrollTeamInstance.init();
                        break;

                    case 'team-scroll':
                        let teamScrollInstance = new TeamScroll(item);
                        teamScrollInstance.init();
                        break;

                    case 'services-scroll':
                        let servicesScrollInstance = new ServicesScroll(item);
                        servicesScrollInstance.init();
                        break;

                    case 'hero':
                        let heroInstance = new Hero(item);
                        heroInstance.init();
                        break;

                    case 'card-carousel':
                        let cardInstance = new Card(item);
                        cardInstance.init();
                        break;
                }
            });
        });
    },

    alwaysLoad() {

    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
